import { render, staticRenderFns } from "./synthesis.vue?vue&type=template&id=fa85768c&scoped=true&"
import script from "./synthesis.vue?vue&type=script&lang=js&"
export * from "./synthesis.vue?vue&type=script&lang=js&"
import style0 from "./synthesis.vue?vue&type=style&index=0&id=fa85768c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa85768c",
  null
  
)

export default component.exports